var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.35403 0.645972L6.35403 5.64597C6.40052 5.69241 6.4374 5.74755 6.46256 5.80825C6.48772 5.86895 6.50067 5.93401 6.50067 5.99972C6.50067 6.06543 6.48772 6.13049 6.46256 6.19119C6.4374 6.25189 6.40052 6.30704 6.35403 6.35347L1.35403 11.3535C1.26021 11.4473 1.13296 11.5 1.00028 11.5C0.867596 11.5 0.740348 11.4473 0.646528 11.3535C0.552707 11.2597 0.5 11.1324 0.5 10.9997C0.5 10.867 0.552707 10.7398 0.646528 10.646L5.2934 5.99972L0.646527 1.35347C0.600072 1.30702 0.563222 1.25187 0.538081 1.19117C0.512939 1.13047 0.5 1.06542 0.5 0.999722C0.5 0.934025 0.512939 0.868971 0.538081 0.808274C0.563222 0.747578 0.600072 0.692427 0.646527 0.645972C0.692982 0.599517 0.748133 0.562667 0.808829 0.537526C0.869526 0.512384 0.93458 0.499444 1.00028 0.499444C1.06597 0.499444 1.13103 0.512384 1.19173 0.537526C1.25242 0.562667 1.30757 0.599517 1.35403 0.645972Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideArrow);
export default __webpack_public_path__ + "static/media/side_arrow.84148f893982ee98ff7858fc4f8b5960.svg";
export { ForwardRef as ReactComponent };